var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchInput",class:{focus: _vm.selectActive, error: _vm.error}},[_vm._t("default"),_c('label',[_vm._v(_vm._s(_vm.nome))]),_c('font-awesome-icon',{attrs:{"icon":['fas', 'search']}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }